module.exports = __webpack_public_path__ + "media/images/vk-b35f89c7315cf3f05fd2e670684402cd.png";